import { Box, styled } from '@mui/material'
import { TreeItem, treeItemClasses } from '@mui/x-tree-view/TreeItem'

export const StyledTreeItem = styled(TreeItem)(({ theme }) => ({
	[`& .${treeItemClasses.content}`]: {
		padding: '1px 4px',
		borderRadius: theme.shape.borderRadius,
		minHeight: 20,
		width: 'max-content',
		minWidth: '100%',
		gap: 2,
	},
	[`& .${treeItemClasses.content}:hover`]: {
		backgroundColor: theme.palette.action.hover,
	},
	[`& .${treeItemClasses.content}.Mui-selected`]: {
		backgroundColor: theme.palette.primary.light,
	},
	[`& .${treeItemClasses.groupTransition}`]: {
		marginLeft: 8,
		paddingLeft: 10,
		position: 'relative',
		// Vertical line using pseudo-element
		'&::before': {
			content: '""',
			position: 'absolute',
			left: 0,
			top: 0,
			width: 1,
			height: 'calc(100% - 10px)', // Stop 10px before bottom (at last child's center)
			backgroundColor: theme.palette.divider,
			transition: 'background-color 0.15s ease',
		},
	},
	// Highlight line when parent is selected
	[`&.Mui-selected > .${treeItemClasses.groupTransition}::before`]: {
		backgroundColor: theme.palette.primary.main,
	},
	// Highlight line on hover - only the directly hovered parent
	[`&:hover:not(:has(.MuiTreeItem-root:hover)) > .${treeItemClasses.groupTransition}::before`]: {
		backgroundColor: theme.palette.primary.light,
	},
	[`& .${treeItemClasses.iconContainer}`]: {
		width: 16,
		minWidth: 16,
		height: 16,
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',
		borderRadius: 2,
		marginRight: 2,
	},
	// Only show hover effect when there's an arrow (has svg inside)
	[`& .${treeItemClasses.iconContainer}:has(svg):hover`]: {
		backgroundColor: theme.palette.action.hover,
		cursor: 'pointer',
	},
	[`& .${treeItemClasses.label}`]: {
		fontSize: '0.8125rem',
		lineHeight: 1.2,
		whiteSpace: 'nowrap',
	},
}))

export const ActionContainer = styled(Box)({
	marginLeft: 'auto',
	display: 'flex',
	alignItems: 'center',
})

